import { render, staticRenderFns } from "./user-area-auth.vue?vue&type=template&id=35df7e07&scoped=true"
import script from "./user-area-auth.vue?vue&type=script&lang=js"
export * from "./user-area-auth.vue?vue&type=script&lang=js"
import style0 from "./user-area-auth.vue?vue&type=style&index=0&id=35df7e07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35df7e07",
  null
  
)

export default component.exports